<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper" [ngClass]="{ 'show-sidebar': showMobileMenu }" [dir]="options.dir"
  [attr.data-theme]="options.theme" [attr.data-layout]="options.layout" [attr.data-sidebartype]="options.sidebartype"
  [attr.data-sidebar-position]="options.sidebarpos" [attr.data-header-position]="options.headerpos"
  [attr.data-boxed-layout]="options.boxed" data-sidebartype="full">
  <!-- ============================================================== -->
  <!-- Topbar header - style you can find in topbar.scss -->
  <!-- ============================================================== -->
  <header class="topbar" [attr.data-navbarbg]="options.navbarbg">
    <nav class="d-flex top-navbar navbar-expand-lg"
      [ngClass]="options.navbarbg == 'skin6' ? 'navbar-light' : 'navbar-dark'">
      <div class="navbar-header" [ngClass]="expandLogo ? 'expand-logo' : ''" [attr.data-logobg]="options.logobg">
        <!-- This is for the sidebar toggle which is visible on mobile only -->
        <a (click)="showMobileMenu = !showMobileMenu" class="nav-toggler waves-effect waves-light d-block d-lg-none"
          href="javascript:void(0)">
          <i [ngClass]="showMobileMenu ? 'ti-close' : 'ti-menu'"></i>
        </a>
        <!-- ============================================================== -->
        <!-- Logo -->
        <!-- ============================================================== -->
        <a class="navbar-brand" href="/starter">
          <!-- Logo icon -->
          <b class="logo-icon">

            <img src="assets/images/logos/solologo-grupo.png" alt="homepagelogo" class="dark-logo" priority=""
              height="45" />
            <!-- Light Logo icon -->
            <img src="assets/images/logos/solologo-grupo.png" alt="homepagelogo" class="light-logo" priority=""
              height="45" />
            <!--End Logo icon -->
          </b>


          <!-- Logo text -->
          <span class="logo-text">
            <!-- dark Logo text -->
            <img src="assets/images/logos/sololetras-grupo.png" alt="homepageletras" class="dark-logo" height="45"
              width="180" />
            <!-- Light Logo text -->
            <img src="assets/images/logos/sololetras-grupo.png" class="light-logo" alt="homepageletras" height="45"
              width="180" />
          </span>
        </a>
        <!-- ============================================================== -->
        <!-- End Logo -->
        <!-- ============================================================== -->


        <!-- ============================================================== -->
        <!-- Toggle which is visible on mobile only -->
        <!-- ============================================================== -->
        <a class="topbartoggler d-block d-lg-none waves-effect waves-light" href="javascript:void(0)"
          (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent">
          <i class="ti-more"></i>
        </a>

      </div>




      <div class="navbar-collapse collapse" id="navbarSupportedContent" [attr.data-navbarbg]="options.navbarbg"
        [ngbCollapse]="!isCollapsed">
        <!-- Horizontal Header -->
        <div *ngIf="options.layout === 'horizontal'; else vheader" class="w-100">
          <app-horizontal-navigation class="w-100 d-flex align-items-center justify-content-between">
          </app-horizontal-navigation>
        </div>

        <!-- Vertical Header -->
        <ng-template #vheader>
          <div class="w-100">
            <app-vertical-navigation (toggleSidebar)="toggleSidebarType()">
            </app-vertical-navigation>
          </div>
        </ng-template>
      </div>
    </nav>
  </header>
  <!-- ============================================================== -->
  <!-- Left Sidebar - style you can find in sidebar.scss  -->
  <!-- ============================================================== -->
  <aside class="left-sidebar" [attr.data-sidebarbg]="options.sidebarbg" (mouseover)="Logo()" (mouseout)="Logo()">
    <!-- Sidebar scroll-->
    <div *ngIf="options.layout === 'horizontal'; else vlayout">
      <app-horizontal-sidebar></app-horizontal-sidebar>
    </div>

    <!-- Horizontal Header -->
    <ng-template #vlayout>
      <ng-scrollbar class="scroll-sidebar">
        <app-vertical-sidebar [showClass]="showMobileMenu" (notify)="handleClick($event)">
        </app-vertical-sidebar>
      </ng-scrollbar>
    </ng-template>
    <!-- End Sidebar scroll-->
  </aside>


  <div class="page-wrapper">
    <!-- <app-breadcrumb></app-breadcrumb> -->
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>


    <app-footer></app-footer>
  </div>

  <aside class="customizer" [ngClass]="{ 'show-service-panel': showSettings }">
    <a href="javascript:void(0)" class="service-panel-toggle" (click)="showSettings = !showSettings">
      <i class="fa fa-spin fa-cog"></i>
    </a>
    <div class="customizer-body custom-pills">
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills nav-justified">
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <i class="mdi mdi-wrench fs-6"></i>
          </a>
          <ng-template ngbNavContent>
            <div class="p-3 border-bottom">
              <h5 class="font-medium mb-4 mt-2">Layout Configuracion</h5>

              <div class="form-check mt-2">
                <input type="checkbox" class="form-check-input" name="theme-view" id="theme-view"
                  [attr.checked]="options.theme == 'dark' ? 'checked' : null" (change)="
                    options.theme = options.theme == 'light' ? 'dark' : 'light'
                  " />
                <label class="form-check-label" for="theme-view">Dark Theme</label>
              </div>
              <div class="form-check mt-2">
                <input type="checkbox" class="form-check-input" name="sidebar-position" id="sidebar-position"
                  [attr.checked]="
                    options.sidebarpos == 'fixed' ? 'checked' : null
                  " (change)="
                    options.sidebarpos =
                      options.sidebarpos == 'fixed' ? 'absolute' : 'fixed'
                  " />
                <label class="form-check-label" for="sidebar-position">Fixed Sidebar</label>
              </div>
              <div class="form-check mt-2">
                <input type="checkbox" class="form-check-input" name="header-position" id="header-position"
                  [attr.checked]="
                    options.headerpos == 'fixed' ? 'checked' : null
                  " (change)="
                    options.headerpos =
                      options.headerpos == 'fixed' ? 'absolute' : 'fixed'
                  " />
                <label class="form-check-label" for="header-position">Fixed Header</label>
              </div>
            </div>

            <div class="p-3 border-bottom" *ngIf="options.layout === 'vertical'">
              <h5 class="font-medium mb-4 mt-2">Logo Backgrounds</h5>
              <ul class="theme-color">
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-logobg="skin1"
                    (click)="options.logobg = 'skin1'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-logobg="skin2"
                    (click)="options.logobg = 'skin2'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-logobg="skin3"
                    (click)="options.logobg = 'skin3'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-logobg="skin4"
                    (click)="options.logobg = 'skin4'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-logobg="skin5"
                    (click)="options.logobg = 'skin5'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-logobg="skin6"
                    (click)="options.logobg = 'skin6'"></a>
                </li>
              </ul>
            </div>
            <div class="p-3 border-bottom">
              <h5 class="font-medium mb-4 mt-2">Navbar Backgrounds</h5>
              <ul class="theme-color">
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-navbarbg="skin1"
                    (click)="options.navbarbg = 'skin1'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-navbarbg="skin2"
                    (click)="options.navbarbg = 'skin2'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-navbarbg="skin3"
                    (click)="options.navbarbg = 'skin3'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-navbarbg="skin4"
                    (click)="options.navbarbg = 'skin4'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-navbarbg="skin5"
                    (click)="options.navbarbg = 'skin5'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-navbarbg="skin6"
                    (click)="options.navbarbg = 'skin6'"></a>
                </li>
              </ul>
            </div>
            <div class="p-3 border-bottom">
              <h5 class="font-medium mb-4 mt-2">Sidebar Backgrounds</h5>
              <ul class="theme-color">
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-sidebarbg="skin1"
                    (click)="options.sidebarbg = 'skin1'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-sidebarbg="skin2"
                    (click)="options.sidebarbg = 'skin2'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-sidebarbg="skin3"
                    (click)="options.sidebarbg = 'skin3'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-sidebarbg="skin4"
                    (click)="options.sidebarbg = 'skin4'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-sidebarbg="skin5"
                    (click)="options.sidebarbg = 'skin5'"></a>
                </li>
                <li class="theme-item">
                  <a href="javascript:void(0)" class="theme-link" data-sidebarbg="skin6"
                    (click)="options.sidebarbg = 'skin6'"></a>
                </li>
              </ul>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </aside>

</div>